export * from '@taqueria/protocol/ConfigArtifactsDir';
